module.exports = {
	"id": "abt520",
	"enabled": false,
	"type": "standard",
	"split": 2,
	"dateRange": [
		{
			"start": "2016-11-01T09:00:00-05:00",
			"end": "2016-11-05T23:59:59-05:00"
		}
	],
	"cookieExpiration": "2016-11-05T23:59:59-05:00",
	"evar": {
		"number": 68,
		"qa": 68,
		"name": "outlook_vs_pdp"
	},
	"customData": {
		"pageType": [
			"browse,pdp"
		],
		"uberCatName": [
			"BBYWI"
		]
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt520/config.json
 ** module id = 34
 ** module chunks = 2
 **/